import { LocationCardState } from '../../../reducers';
import { FlowType } from '../../../../models/location-card.model';
import { SensorMonitoringPointDataSource } from '../../../models/dynamic-section-models';

export enum FlexScanModeValue {
    Normal = 1,
    Fast = 2,
}

export interface FlexScanModeOption {
    id: FlexScanModeValue;
    value: FlexScanModeValue;
    text: string;
}

export interface FlexMonitorConfiguration {
    customerId: number;
    locationId: number;
    normalStorageInterval: number;
    fastStorageInterval: number;
    scanMode?: FlexScanModeValue | null;
    telemetryNormalInterval: number;
    telemetryFastInterval: number;
    monitorPoint1Enable: boolean;
    monitorPoint1InstallationType: number;
    monitorPoint1InstallationHeight: number;
    monitorPoint1InstallationWidth: number;
    monitorPoint1Silt: number;
    monitorPoint1HC: number;
    monitorPoint1FlowType: FlowType;
    monitorPoint2FlowType: FlowType;
    monitorPoint2Enable: boolean;
    monitorPoint2InstallationType: number;
    monitorPoint2InstallationHeight: number;
    monitorPoint2InstallationWidth: number;
    devices: DeviceConfig[];
    silts: number[];
    mp1Preferences?: SensorMonitoringPointDataSource;
    mp2Preferences?: SensorMonitoringPointDataSource;
}

export interface BaseDeviceConfig {
    type: string;
    name: string;
    installationNumber: number;
    active: boolean;
}

export interface AlarmDevice extends BaseDeviceConfig {
    rainEnable: boolean;
    rainThreshold: number;
    rainReturnToNormal: number;
    batteryLowEnable: boolean;
    batteryLowThreshold: number;
    batteryDeadEnable: boolean;
    temperatureInternalEnable: boolean;
    temperatureExternalEnable: boolean;
    temperaturePseudoEnable: boolean;
    lowLevelEnable: boolean;
    lowLevelThreshold: number;
    highLevelEnable: boolean;
    highLevelThreshold: number;
    highHighEnable: boolean;
    highHighThreshold: number;
    fullPipeEnable: boolean;
    fullPipeThreshold: number;
    overflowEnable: boolean;
    overflowThreshold: number;
    tiltEnable: boolean;
    tiltThreshold: number;
    unidepthsToAverage: number;
    highFlowEnable: boolean;
    highFlowThreshold: number;
}

export interface FlowLossAlarmDevice extends BaseDeviceConfig {
    percent: number;
    sensitivity: number;
    flowLossType: number;
    clearPatternHistory: boolean;
}

export type DeviceConfig = AlarmDevice | FlowLossAlarmDevice;

export type FlexLocationCardState = LocationCardState<FlexMonitorConfiguration>;
